export class FetchGradingSchemeByModuleIdFailure {
    static readonly type = '[GradingScheme] FetchGradingSchemeByModuleIdFailure';
}
